import React, { useState, useMemo } from "react";
import { formatCurrencyIndian, WorkStatModal } from "../../CustomFunctions";
import UpdateRopewayProject from "./UpdateRopewayProject";
import { DeleteProjectName } from "../Projectname/AddProjectName";
import { toast } from "react-toastify";

/* ─── natural-sort helper (HP-001 < HP-002 < HP-010) ─── */
const naturalCompare = (a = "", b = "") =>
    a.localeCompare(b, undefined, { numeric: true, sensitivity: "base" });

/* ─── Sort indicator icon ─── */
const SortIcon = ({ colKey, sortConfig }) => {
    const isActive = sortConfig.key === colKey;
    const dir      = sortConfig.direction;
    return (
        <span style={{
            display: "inline-flex",
            flexDirection: "column",
            gap: "1px",
            marginLeft: 5,
            verticalAlign: "middle",
            opacity: isActive ? 1 : 0.35,
            transition: "opacity 0.15s",
        }}>
            <svg width="7" height="5" viewBox="0 0 7 5">
                <path d="M3.5 0L7 5H0z"
                    fill={isActive && dir === "asc" ? "#2576bc" : "#9ca3af"} />
            </svg>
            <svg width="7" height="5" viewBox="0 0 7 5">
                <path d="M3.5 5L0 0H7z"
                    fill={isActive && dir === "desc" ? "#2576bc" : "#9ca3af"} />
            </svg>
        </span>
    );
};

// ✅ ProjectFilter import removed — filter is now handled in RopewayPage
const RopewaysProject = ({ projectName, getProjectname, buffer, hideSector, getProject = false }) => {

    const [selectedItem, setSelectedItem] = useState(null);
    const [isModalOpen, setIsModalOpen]   = useState(false);
    const [modalType, setModalType]       = useState("");
    const [expandedStages, setExpandedStages] = useState({});
    

    /* ─── sort state ─── */
    const [sortConfig, setSortConfig] = useState({ key: null, direction: null });

    /* ─── Sort cycle: asc → desc → reset ─── */
    const handleSort = (key) => {
        setSortConfig((prev) => {
            if (prev.key !== key)           return { key, direction: "asc" };
            if (prev.direction === "asc")   return { key, direction: "desc" };
            if (prev.direction === "desc")  return { key: null, direction: null };
            return { key, direction: "asc" };
        });
    };

    /* ─── Sorted list ─── */
    const sortedProjects = useMemo(() => {
        if (!projectName?.length) return projectName || [];
        if (!sortConfig.key || !sortConfig.direction) return projectName;
        return [...projectName].sort((a, b) => {
            let cmp = 0;
            if (sortConfig.key === "pr_code") {
                cmp = naturalCompare(a.pr_code || "", b.pr_code || "");
            }
            return sortConfig.direction === "asc" ? cmp : -cmp;
        });
    }, [projectName, sortConfig]);

    const truncateText = (text, wordLimit = 10) => {
        if (!text) return "-";
        const words = text.split(' ');
        if (words.length <= wordLimit) return text;
        return words.slice(0, wordLimit).join(' ') + '...';
    };

    const handleViewProjectName = (item) => {
        setSelectedItem(item);
        setModalType("project_name");
        setIsModalOpen(true);
    };

    const handleViewWorkstages = (workstages) => {
        setSelectedItem(workstages);
        setModalType("workstages_list");
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
        setSelectedItem(null);
        setModalType("");
    };
    const toggleStages = (id, e) => {
    e.stopPropagation();
    setExpandedStages((prev) => ({ ...prev, [id]: !prev[id] }));
  };

    return (
    <>
      

      <style>{`
        .ept-wrap {
          width: 100%;
          border-collapse: collapse;
          font-size: 12px;
          font-family: sans-serif;
        }

        .ept-thead th {
          padding: 9px 12px;
          text-align: left;
          font-size: 11px;
          font-weight: 500;
          color: #9ca3af;
          letter-spacing: 0.05em;
          text-transform: uppercase;
          border-bottom: 0.5px solid #e5e7eb;
          background: #f9fafb;
          white-space: nowrap;
        }

        .ept-th-sort {
          cursor: pointer;
          user-select: none;
          transition: color 0.15s, background 0.15s;
        }
        .ept-th-sort:hover  { color: #374151; background: #f3f4f6; }
        .ept-th-sort.active { color: #1e40af; background: #eff6ff; }

        .ept-sort-badge {
          display: inline-block;
          font-size: 9px;
          font-weight: 700;
          padding: 1px 5px;
          border-radius: 3px;
          margin-left: 5px;
          background: #1e40af;
          color: #fff;
          vertical-align: middle;
          letter-spacing: 0.03em;
        }

        .ept-row {
          border-bottom: 0.5px solid #f3f4f6;
          cursor: pointer;
          transition: background 0.12s;
        }
        .ept-row:last-child { border-bottom: none; }
        .ept-row:hover { background: #f9fafb; }

        .ept-row td {
          padding: 10px 12px;
          vertical-align: middle;
          color: #111827;
        }

        .ept-sno { font-size: 11px; color: #9ca3af; }

        .ept-code {
          font-size: 11px;
          font-weight: 500;
          background: #1e40af;
          color: #fff;
          padding: 2px 7px;
          border-radius: 3px;
          letter-spacing: 0.04em;
          display: inline-block;
          white-space: nowrap;
        }

        .ept-name {
          font-weight: 500;
          font-size: 12px;
          color: #1e40af;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          max-width: 180px;
        }
        .ept-shortname {
          font-size: 11px;
          color: #9ca3af;
          margin-top: 2px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          max-width: 180px;
        }

        .ept-date-label {
          font-size: 10px;
          color: #9ca3af;
          letter-spacing: 0.04em;
          margin-bottom: 1px;
        }
        .ept-date { font-size: 12px; color: #111827; }

        .ept-cost { font-weight: 500; font-size: 12px; }
        .ept-cost-unit { font-size: 10px; color: #9ca3af; }

        .ept-sector-dot {
          display: inline-block;
          width: 6px;
          height: 6px;
          border-radius: 50%;
          margin-right: 5px;
          vertical-align: middle;
        }

        .ept-tag {
          font-size: 10px;
          border: 0.5px solid #e5e7eb;
          border-radius: 3px;
          padding: 2px 7px;
          color: #6b7280;
          background: #fff;
          display: inline-block;
          white-space: nowrap;
        }

        .ept-stages { display: flex; flex-wrap: wrap; gap: 4px; align-items: center; }

        .ept-stage-pill {
          font-size: 10px;
          font-weight: 500;
          padding: 2px 7px;
          border-radius: 3px;
          border: 0.5px solid #e5e7eb;
          color: #374151;
          background: #f9fafb;
          white-space: nowrap;
        }

        .ept-stage-more {
          font-size: 10px;
          color: #1e40af;
          font-weight: 500;
          cursor: pointer;
          padding: 2px 6px;
          border-radius: 3px;
          background: #eff6ff;
          border: 0.5px solid #bfdbfe;
        }
        .ept-stage-more:hover { background: #dbeafe; }

        .ept-actions { display: flex; gap: 6px; align-items: center; justify-content: flex-end; }

        .ept-empty { text-align: center; padding: 60px 20px; color: #9ca3af; }
        .ept-empty-text { font-size: 13px; font-weight: 500; margin-top: 8px; }

        .tbl-outer {
          border: 0.5px solid #e5e7eb;
          border-radius: 8px;
          overflow: hidden;
          background: #fff;
        }
      `}</style>

      <div className="sec-outer table-box scroll-container-table" style={{ height: "80vh" }}>
          <table className="ept-wrap">
            <thead className="ept-thead">
              <tr>
                <th style={{ width: 36 }}>No.</th>

                <th
                  className={`ept-th-sort${sortConfig.key === "pr_code" ? " active" : ""}`}
                  onClick={() => handleSort("pr_code")}
                  title="Click to sort by Project Code"
                >
                  Code
                  <SortIcon colKey="pr_code" sortConfig={sortConfig} />
                  {sortConfig.key === "pr_code" && sortConfig.direction && (
                    <span className="ept-sort-badge">
                      {sortConfig.direction === "asc" ? "A→Z" : "Z→A"}
                    </span>
                  )}
                </th>

                <th>Short Name</th>
                <th>Project</th>
                <th>LOA Date</th>
                <th>Completion</th>
                <th>Cost (Lakhs)</th>
                <th>Length</th>
                <th>Sector</th>
                <th>Department</th>
                <th>Work Type</th>
                <th>Workstages</th>
                <th>Company</th>
                <th>Sub Company</th>
                <th style={{ textAlign: "right" }}>Actions</th>
              </tr>
            </thead>

            {buffer ? (
              <tbody>
                <tr>
                  <td colSpan={15}>
                    <div className="spinner-bgdatil" />
                  </td>
                </tr>
              </tbody>
            ) : (
              <tbody>
                {!sortedProjects?.length ? (
                  <tr>
                    <td colSpan={15}>
                      <div className="ept-empty">
                        <div className="ept-empty-text">No projects found</div>
                      </div>
                    </td>
                  </tr>
                ) : (
                  sortedProjects.map((i, index) => {
                    const sectorDotColor =
                      i.sector_details?.name === "Ropeway"
                        ? "#1D9E75"
                        : i.sector_details?.name === "Highway"
                        ? "#378ADD"
                        : "#8B5CF6";

                    const stages = i.workstages_details || [];
                    const showAll = expandedStages[i.id];
                    const visibleStages = showAll ? stages : stages.slice(0, 2);
                    const hiddenCount = stages.length - 2;

                    return (
                      <tr
                        key={i.id || index}
                        className="ept-row"
                        onClick={() => handleViewProjectName(i)}
                      >
                        <td className="ept-sno">{index + 1}</td>

                        <td>
                          <span className="ept-code">{i.pr_code || "-"}</span>
                        </td>

                        <td>
                          <span className="ept-tag">{i.project_short_name || "—"}</span>
                        </td>

                        <td style={{ maxWidth: 200 }}>
                          <div className="ept-name">
                            {i.project_name?.length > 40
                              ? i.project_name.slice(0, 40) + "…"
                              : i.project_name || "-"}
                          </div>
                        </td>

                        <td>
                          <div className="ept-date-label">LOA</div>
                          <div className="ept-date">{i.loa_date || "—"}</div>
                        </td>

                        <td>
                          <div className="ept-date-label">Due</div>
                          <div className="ept-date">{i.completion_date || "—"}</div>
                        </td>

                        <td>
                          <div className="ept-cost">
                            ₹{formatCurrencyIndian(Number(i.project_post / 100000).toFixed(2)) || 0}
                          </div>
                          <div className="ept-cost-unit">Lakhs</div>
                        </td>

                        <td>
                          {(Number(i.total_length) || 0).toFixed(3)} KM
                        </td>

                        <td>
                          <span
                            className="ept-sector-dot"
                            style={{ background: sectorDotColor }}
                          />
                          {i.sector_details?.name || "—"}
                        </td>

                        <td>
                          <span className="ept-tag">{i.department || "—"}</span>
                        </td>

                        <td>
                          <span className="ept-tag">
                            {i.worktype_details?.name || "—"}
                          </span>
                        </td>

                        <td
                          style={{ minWidth: 140 }}
                          onClick={(e) => e.stopPropagation()}
                        >
                          <div className="ept-stages">
                            {visibleStages.map((ws, wi) => (
                              <span key={ws.id || wi} className="ept-stage-pill">
                                {ws.name || ws}
                              </span>
                            ))}
                            {hiddenCount > 0 && (
                              <button
                                className="ept-stage-more"
                                onClick={(e) => toggleStages(i.id, e)}
                              >
                                {showAll ? "less" : `+${hiddenCount}`}
                              </button>
                            )}
                          </div>
                        </td>

                        <td>
                          <span
                            className="ept-tag"
                            style={{
                              maxWidth: 120,
                              display: "inline-block",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {i.SubCompany_details?.company_name || "—"}
                          </span>
                        </td>

                        <td>
                          <span className="ept-tag">{i.division_name || "—"}</span>
                        </td>

                        <td onClick={(e) => e.stopPropagation()}>
                          <div className="ept-actions">
                            <UpdateRopewayProject i={i} getProjectname={getProjectname} getProject={getProject} />
                            <DeleteProjectName i={i} getProjectname={getProjectname} />
                          </div>
                        </td>
                      </tr>
                    );
                  })
                )}
              </tbody>
            )}
          </table>
        </div>

      {modalType === "project_name" && (
        <WorkStatModal
          isOpen={isModalOpen}
          onClose={handleCloseModal}
          data={selectedItem}
          usedFor="project_name"
        />
      )}

      {modalType === "workstages_list" && (
        <WorkStatModal
          isOpen={isModalOpen}
          onClose={handleCloseModal}
          data={selectedItem}
          usedFor="workstages_list"
        />
      )}
    </>
  );
};

export default RopewaysProject;